export enum FILE_TYPE {
    INVOICE = 600,
    INPUTWORKFLOW_FILE = 603,
    INVOICE_ATTACHMENT = 604
}

export enum FILE_STATE {
    NONE,
    NEW,
    LOADED_FROM_DB,
    SAVED_TO_DB,
    HAS_CHANGED,
    WAS_DELETED
}

export enum FILE_ORIGIN {
    CLOUD = 1,
    ERP = 2,
    DMS = 3,
    EMONITOR = 4
}

export enum FILE_ENTITY {
    CRED_INVOICES = "cred.invoices",
    TICKET_INCIDENTS = "ticket.incidents"
}
